import { render, staticRenderFns } from "./ExpertListItem.vue?vue&type=template&id=39622d13&"
import script from "./ExpertListItem.vue?vue&type=script&lang=js&"
export * from "./ExpertListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports